module.exports = __webpack_public_path__ + "static/assets/bce9d620b456d81b439ec427e0332f23.gif";